﻿import { OpaccBrowser } from './vendor/script/classes/opacc.class.browser.js';
import { OpaccCookie } from './vendor/script/classes/opacc.class.cookie.js';
import { OpaccTag } from './art.class.tag.js';
import { OpaccSession } from './vendor/script/classes/opacc.class.session.js';

export const opaccBrowserPlugin = new OpaccBrowser();
export const opaccCookiePlugin = new OpaccCookie();
export const opaccTagPlugin = new OpaccTag();
export const opaccSessionPlugin = new OpaccSession();

